import React, { useState } from 'react';
import { KeyRound, PauseCircle, PlayCircle } from 'lucide-react';
import { toast } from 'react-toastify';
import { updateCamaraApagada } from '../../../camaraManager/api/camaraManager.api';

const Licencia = ({ feedID, daysLeft = 0, totalDays = 0, camaraApagada = false, onCamaraApagadaChange }) => {
  const [isUpdating, setIsUpdating] = useState(false);

  const safeTotalDays = totalDays > 0 ? totalDays : 1;
  const percentage = Math.min(100, Math.max(0, (daysLeft / safeTotalDays) * 100));
  const barColor = daysLeft <= 0 ? 'bg-red-500' : percentage <= 25 ? 'bg-amber-500' : 'bg-blue-600';

  const handleToggle = async () => {
    const nextValue = !camaraApagada;
    setIsUpdating(true);
    try {
      await updateCamaraApagada(feedID, nextValue);
      onCamaraApagadaChange && onCamaraApagadaChange(nextValue);
      toast.success(nextValue ? 'Ingreso de imágenes detenido.' : 'Ingreso de imágenes reanudado.');
    } catch (error) {
      toast.error('No se pudo actualizar el estado de la cámara.');
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <div className="space-y-4">
      <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-5">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-9 h-9 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center">
            <KeyRound size={18} />
          </div>
          <h3 className="text-base font-semibold text-gray-800">Licencia</h3>
        </div>

        <div className="flex items-end justify-between mb-2">
          <span className="text-sm text-gray-600">Días disponibles</span>
          <span className="text-sm font-semibold text-gray-800">
            {Math.max(daysLeft, 0)} / {totalDays} días
          </span>
        </div>
        <div className="w-full h-3 bg-gray-100 rounded-full overflow-hidden">
          <div
            className={`h-full rounded-full transition-all ${barColor}`}
            style={{ width: `${percentage}%` }}
          />
        </div>
        {daysLeft <= 0 && (
          <p className="text-sm text-red-600 mt-2">La licencia contratada ya no tiene días disponibles.</p>
        )}
      </div>

      <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-5">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className={`w-9 h-9 rounded-full flex items-center justify-center ${camaraApagada ? 'bg-gray-100 text-gray-500' : 'bg-green-100 text-green-600'}`}>
              {camaraApagada ? <PauseCircle size={18} /> : <PlayCircle size={18} />}
            </div>
            <div>
              <p className="text-sm font-semibold text-gray-800">Ingreso de imágenes</p>
              <p className="text-xs text-gray-500">
                {camaraApagada ? 'Detenido: la cámara no recibirá nuevas imágenes.' : 'Activo: la cámara sigue recibiendo imágenes.'}
              </p>
            </div>
          </div>
          <button
            type="button"
            role="switch"
            aria-checked={camaraApagada}
            disabled={isUpdating}
            onClick={handleToggle}
            className={`w-11 h-6 flex items-center rounded-full p-1 transition-colors shrink-0 ${
              camaraApagada ? 'bg-gray-400' : 'bg-blue-600'
            } ${isUpdating ? 'opacity-60 cursor-wait' : ''}`}
          >
            <div
              className={`bg-white w-4 h-4 rounded-full shadow-md transform transition-transform ${
                camaraApagada ? 'translate-x-0' : 'translate-x-5'
              }`}
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Licencia;
